export default __webpack_public_path__ + "static/media/apollo_work.b96d33e7.png";